import { domain } from 'modules/data';
import { FC, memo } from 'react';
import styled from 'styled-components';

import SectionSeparator from '../../../components/SectionSeparator/SectionSeparator';
import ContactInformationSection from './components/ContactInformationSection/ContactInformationSection';
import ContactPersonsSection from './components/ContactPersonsSection/ContactPersonsSection';
import FinanceSection from './components/FinanceSection/FinanceSection';
import { PaymentDetailsSection } from './components/PaymentDetailsSection/PaymentDetailsSection';
import PostalAddressSection from './components/PostalAddressSection/PostalAddressSection';

interface QbooksVendorFieldsProps {
    className?: string;
    contactData: domain.QBooksVendor;
}

const Root = styled.div`
    padding: 20px 60px;
`;

const QbooksVendorFields: FC<QbooksVendorFieldsProps> = memo(({ contactData }) => {
    return (
        <Root>
            <ContactPersonsSection contactData={contactData} />

            <SectionSeparator />

            <ContactInformationSection contactData={contactData} />

            <PostalAddressSection contactData={contactData} />

            <PaymentDetailsSection contactData={contactData} />

            <FinanceSection contactData={contactData} />
        </Root>
    );
});

export default QbooksVendorFields;
